/* ============================================================
   FilterChip — shared pill toggle for status-filter rows.
   Extracted verbatim from ProviderOrdersPanel (TASK-256 styling)
   by TASK-16aeb9c6 so the customer OrdersPage copies the exact
   provider pattern instead of forking the styles.
   Light theme, Montserrat, iOS-18 minimal per DESIGN-SYSTEM.md.
   ============================================================ */

export function FilterChip({ active, onClick, label }: { active: boolean; onClick: () => void; label: string }) {
  return (
    <button
      onClick={onClick}
      style={{
        padding: '6px 14px',
        borderRadius: 'var(--radius-pill)',
        fontSize: 'var(--fs-caption)',
        fontWeight: active ? 'var(--fw-semibold)' : 'var(--fw-medium)',
        background: active ? 'var(--color-primary)' : 'var(--color-surface)',
        color: active ? '#FFFFFF' : 'var(--color-text-secondary)',
        border: active ? 'none' : '1px solid var(--color-separator)',
        transition: 'all var(--transition-fast)',
      }}
    >
      {label}
    </button>
  );
}
